import { basicTask, generateSVG } from "./task";
import { swiperInit } from "./swiper";
import {
	animate,
	createSpring,
	stagger,
	utils,
	text,
	svg,
	createTimeline,
} from "animejs"
const bodyWrap = document.querySelector("body");
const sideNav = document.querySelector(".sidenav-group");
const hamburger = document.querySelector(".hamburger");
const menuMobile = document.querySelector(".mobile-nav-wrap");
const searchWrap = document.querySelector(".searchbox");
let resizeTimeout;


gsap.registerPlugin(ScrollTrigger);

// Wait for both window load and SVG animation to finish


document.addEventListener("DOMContentLoaded", () => {

	mappingFunc();
	swiperInit();
	generateSVG();
	basicTask();
	const observer = lozad(".lozad", {
		rootMargin: "10px 0px", // syntax similar to that of CSS Margin
		threshold: 0.1, // ratio of element convergence
		enableAutoReload: true, // it will reload the new image when validating attributes changes
	});
	observer.observe();
	window.lozadObserver = observer;



	try {

		if ($(window).width() > 1200.1) {
			fullPageInit();

		}
		aosInit();


	} catch (error) {

	}
	generalFunction.init();
});


window.addEventListener("resize", function () {
	// Clear any existing timeout. If the user resizes again within
	// the 0.5s, the previous delayed execution will be cancelled.
	clearTimeout(resizeTimeout);

	// Set a new timeout. The functions inside will only execute
	// if no new 'resize' event occurs for 500 milliseconds (0.5 seconds).
	resizeTimeout = setTimeout(() => {
		let width = this.window.innerWidth;
		if (width <= 1200.1) {
			mappingFunc();
			generalFunction.init();
		}
	}, 1000); // 500 milliseconds = 0.5 seconds
});
window.addEventListener("scroll", function () {
	const width = this.window.innerWidth;
	const scrollTop = window.scrollY || document.documentElement.scrollTop;
	if (width >= 1200.1) {
		if (
			document.body.scrollTop > 100 ||
			document.documentElement.scrollTop > 100
		) {
			bodyWrap.classList.add("minimize");
		} else {
			bodyWrap.classList.remove("minimize");
		}
	}
	try {
		if (scrollTop > window.innerHeight) {
			sideNav.classList.add("show");
		} else {
			sideNav.classList.remove("show");
		}
	} catch (error) {

	}

});
document.addEventListener("click", (event) => {
	if (!event.target.closest(".search-toggle, .search-overlay")) {
		searchWrap.classList.remove("is-open");
	}
	if (!event.target.closest(".mobile-nav-wrap, .site-menu-toggle")) {
		menuMobile.classList.remove("is-open");
		bodyWrap.classList.remove("overlay-bg");
		hamburger.classList.remove("is-active");
	}
});

Fancybox.bind("[data-fancybox]", {
	parentEl: document.body[0], // Element containing main structure
});

const generalFunction = {
	intro: () => {
		if ($(window).width() > 1200.1) {
			document.body.addEventListener("svg-loaded", (e) => {
				const { element, isError } = e.detail
				if (isError) return
				const intro = element.closest(".intro")
				if (!intro) return
				const currentSvg = element.querySelector("svg")
				utils.set(currentSvg, {
					opacity: 1,
				})
				const img = intro.querySelector(".img")
				const icon = element.querySelector("#icon")
				const iconPaths = icon.querySelectorAll("path")
				const characters = element.querySelectorAll(".character")
				const draw_fill = element.querySelectorAll(".draw-fill")
				const gridItem = intro.querySelectorAll(".grid span")
				utils.set([characters], {
					"--initial-fill": (path) => path.getAttribute("fill"),
					fill: "#ffffff00",
					transformOrigin: "center",
				})
				utils.set([draw_fill], {
					"--initial-fill": (path) => path.getAttribute("fill"),
					fill: "#ffffff00",
					transformOrigin: "center",
				})
				utils.set(iconPaths, {
					transformOrigin: "center",
					y: (_, i) => (i % 2 === 0 ? "-50%" : "50%"),
				})
				const tl = createTimeline({
					defaults: {
						duration: 800,
					},
				})
				tl.add(iconPaths, {
					y: 0,
					strokeWidth: 0,
				})
				tl.add(svg.createDrawable([...characters]), {
					draw: ["0 0", "0 1"],
					duration: 200,
					ease: "outCirc",
					onUpdate: (anim) => {
						utils.set([icon, ...characters], {
							strokeWidth: `${1 - anim.progress}`,
						})
					},
				})
				tl.add(svg.createDrawable([...draw_fill]), {
					draw: ["0 0", "0 1"],
					duration: 200,
					ease: "outCirc",
					onUpdate: (anim) => {
						utils.set([icon, ...draw_fill], {
							strokeWidth: `${1 - anim.progress}`,
						})
					},
				})
				tl.add(
					characters,
					{
						fill: (path, i) => {
							const style = path.getAttribute("style")
							const fill = style.split("fill:")[1].split(";")[0]
							// ~ fill:  rgba(0,0,0,1)
							return fill
						},
					},
					"*=.8"
				)
				tl.add(
					draw_fill,
					{
						fill: (path, i) => {
							const style = path.getAttribute("style")
							const fill = style.split("fill:")[1].split(";")[0]
							// ~ fill:  rgba(244,0,0,1)
							return fill
						},
					},
					"*=.8"
				)
				tl.add(gridItem, {
					x: (item, i) => (i % 2 === 0 ? "-100%" : "100%"),
					onUpdate: (anim) => {
						utils.set(intro, {
							opacity: 1 - anim.progress,
						})
					},
					onComplete: () => {
						intro.remove()
					},
				})
			})
		}
	},




	scrollReveal: () => {
		if ($(window).width() > 1200.1) {
			// Function to process custom attributes
			function revealWithAttributes(selector, baseConfig) {
				document.querySelectorAll(selector).forEach((element) => {
					// Read custom attributes
					const delay = element.getAttribute("data-delay") || baseConfig.delay;
					const duration = element.getAttribute("data-duration") || baseConfig.duration;
					const distance = element.getAttribute("data-distance") || baseConfig.distance;

					// Create a new configuration based on custom attributes
					const config = {
						...baseConfig,
						delay: parseInt(delay, 10),
						duration: parseInt(duration, 10),
						distance: distance,
					};

					// Apply ScrollReveal
					ScrollReveal().reveal(element, { mobile: false, once: true, ...config, easing: "cubic-bezier(0.5, 0, 0, 1)" });

					// Trigger animation for elements already in viewport
					const rect = element.getBoundingClientRect();
					if (rect.top < window.innerHeight && rect.bottom >= 0) {
						ScrollReveal().reveal(element, config);
					}
				});
			}

			// Base configurations
			let fadeDown = { origin: "top", duration: 1000, delay: 200, distance: "20px", interval: 50, reset: false };
			let fadeUp = { origin: "bottom", duration: 1000, delay: 200, distance: "20px", interval: 50, reset: false };
			let fadeLeft = { origin: "left", duration: 1000, delay: 200, distance: "25%", interval: 150, reset: false };
			let fadeRight = { origin: "right", duration: 1000, delay: 200, distance: "25%", interval: 150, reset: false };
			let fadeIn = { origin: "top", duration: 1100, delay: 220, distance: 0, interval: 150, reset: false };

			// Call the function for each selector
			revealWithAttributes(".fd-down", fadeDown);
			revealWithAttributes(".fd-up", fadeUp);
			revealWithAttributes(".fd-left", fadeLeft);
			revealWithAttributes(".fd-right", fadeRight);
			revealWithAttributes(".fd-in", fadeIn);
		}

	},






	a11yUser: () => {
		const wrapForms = document.querySelectorAll(".wrap-form");
		wrapForms.forEach(function (form) {
			const submitInput = form.querySelector("input[type='submit']");
			const labelFor = submitInput.getAttribute("name");
			const labelSubmit = form.querySelector(".frm-btnwrap .label");
			if (labelFor !== null) {
				if (labelSubmit !== null) {
					labelSubmit.textContent = "Submit Button";
					labelSubmit.setAttribute("for", labelFor);
				}
			}
		});
	},
	hideElement: () => {
		if ($(window).width() < 1200.1) {
			[".header-social", ".header-contact"]
				.map((selector) => document.querySelector(selector))
				.forEach((el) => (el.style.display = "flex"));
		}
	},

	figureImage: () => {
		if ($(".project-deail-2 .fullcontent table").length) {
			$(".project-deail-2 .fullcontent table").wrap(
				"<div class='table-res'></div>"
			);
		}
		if ($("body").hasClass("news-detail-page")) {
			if ($(".news-detail .fullcontent iframe").length) {
				$(".news-detail .fullcontent iframe").wrap(
					"<div class='iframe-ratio'></div>"
				);
			}

			$(".news-detail-page .fullcontent img").each(function (index, element) {
				let _this = $(element);
				let caption = _this.attr("title");
				if (caption) {
					let figure = $("<figure></figure>");
					_this.wrap(figure);
					let figcaption = $(`<figcaption>${caption}</figcaption>`);
					figcaption.insertAfter(_this);
				}
			});
		}

	},
	init: () => {
		generalFunction.figureImage();
		generalFunction.scrollReveal();

		generalFunction.intro();
	},
};


function mappingFunc() {
	new MappingListener({
		selector: ".header-contact",
		mobileWrapper: ".sidenav-group",
		mobileMethod: "appendTo",
		desktopWrapper: ".language-wrap",
		desktopMethod: "insertBefore",
		breakpoint: 1200.1,
	}).watch();
	new MappingListener({
		selector: ".header-social",
		mobileWrapper: ".sidenav-group",
		mobileMethod: "appendTo",
		desktopWrapper: ".site-menu-toggle",
		desktopMethod: "insertBefore",
		breakpoint: 1200.1,
	}).watch();

}


function fullPageInit() {
	try {
		const headerHeight = $("#header").outerHeight();
		let arrayAnchor = [];
		if ($("#menu-parallax").length) {
			let menuParallax = $("#menu-parallax li");
			for (let index = 0; index < menuParallax.length; index++) {
				let item = $(menuParallax[index]);
				let val = item.attr("data-menuanchor");
				arrayAnchor.push(val);
			}
		} else {
			arrayAnchor = [
				"fp-block-1",
				"fp-block-2",
				"fp-block-3",
				"fp-block-4",
				"fp-block-5",
				"fp-block-6",
				"fp-block-7",
				"fp-block-8",
				"fp-block-9",
				"fp-block-10",
				"fp-block-11",
				"fp-block-12",
				"fp-block-13",
			];
		}
		var myFullpage = new fullpage("#fullpage", {
			bigSectionsDestination: null,
			menu: "#header,#menu-parallax",
			lockAnchors: false,
			fixedElements: "#header,#menu-parallax,.sidenav-group",
			anchors: arrayAnchor,
			navigationTooltips: arrayAnchor,
			normalScrollElements: ".scrollbar-wrap,.popup-modal",
			slidesNavigation: true,
			slidesNavPosition: "bottom",
			showActiveTooltip: true,
			//Scrolling
			css3: true,
			offsetSections: true,
			scrollingSpeed: 700,
			autoScrolling: true,
			fitToSection: false,
			paddingTop: headerHeight + "px",
			fitToSectionDelay: 600,
			scrollBar: false,
			easing: "easeInOutCubic",
			easingcss3: "ease",
			loopBottom: false,
			loopTop: false,
			loopHorizontal: true,
			continuousHorizontal: true,
			scrollHorizontally: true,
			continuousVertical: false,
			scrollOverflow: false,
			touchSensitivity: 15,
			normalScrollElementTouchThreshold: 5,
			//Accessibility
			keyboardScrolling: true,
			animateAnchor: true,
			recordHistory: true,
			//Design
			controlArrows: true,
			verticalCentered: true,
			resize: false,
			responsiveWidth: 0,
			responsiveHeight: 0,
			//Custom selectors
			sectionSelector: "section",
			dragAndMove: true,
			afterRender: function () {
				$("body").addClass("body-has-fp");
			},
			onLeave: function (origin, destination, direction) {
				$("section [data-aos]").removeClass("aos-animate");
				// Get the current section (the section that just became fully visible)
				var totalSections = document.querySelectorAll('#fullpage section').length;
				var currentSection = destination.item;

				// Check if the current section has the class "section-white"

				if (currentSection.classList.contains("nav-green")) {
					$("body").addClass("fp-nav-green");
					$("#menu-parallax").addClass("fp-nav-green");
				} else {
					$("body").removeClass("fp-nav-green");
					$("#menu-parallax").removeClass("fp-nav-green");
				}
				if (destination.index === 0) {
					$(".sidenav-group").removeClass("is-visible");
				} else {
					$(".sidenav-group").addClass("is-visible");
				}

			},
			onSlideLeave: function () {
				$("section [data-aos]").removeClass("aos-animate");
			},
			afterSlideLoad: function () {
				$("section.active [data-aos]").addClass("aos-animate");

			},
			afterLoad: function (origin, destination, direction) {
				$("section.active [data-aos]").addClass("aos-animate");
				var totalSections = document.querySelectorAll('#fullpage section').length;
				if (destination.index === 0) {
					var currentSection = destination.item;
					// Check if the current section has the class "section-white"
					if (currentSection.classList.contains("section-white")) {
						$("body").addClass("fp-body-white");
					} else {
						$("body").removeClass("fp-body-white");
					}
					if (currentSection.classList.contains("nav-white")) {
						$("body").addClass("fp-nav-white");
						$("#menu-parallax").addClass("fp-nav-white");
					} else {
						$("body").removeClass("fp-nav-white");
						$("#menu-parallax").removeClass("fp-nav-white");
					}


				}


			},
		});
	} catch (error) { }
}


function aosInit() {
	AOS.init({
		// Global settings:

		disable: window.innerWidth < 1200,
		startEvent: "load", // name of the event dispatched on the document, that AOS should initialize on
		initClassName: "aos-init", // class applied after initialization
		animatedClassName: "aos-animate", // class applied on animation
		useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
		disableMutationObserver: false, // disables automatic mutations' detections (advanced)
		debounceDelay: 20, // the delay on debounce used while resizing window (advanced)
		throttleDelay: 0, // the delay on throttle used while scrolling the page (advanced)
		// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
		offset: 120, // offset (in px) from the original trigger point
		delay: 120, // values from 0 to 3000, with step 50ms
		duration: 500, // values from 0 to 3000, with step 50ms
		easing: "ease-in-out-back", // default easing for AOS animations
		once: true,
		mirror: true, // whether elements should animate out while scrolling past them
		anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
	});
}

